import { render, staticRenderFns } from "./BooleanFormInput.vue?vue&type=template&id=063f30d1&scoped=true&"
import script from "./BooleanFormInput.vue?vue&type=script&lang=ts&"
export * from "./BooleanFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./BooleanFormInput.vue?vue&type=style&index=0&id=063f30d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f30d1",
  null
  
)

export default component.exports